import auth from '../../middlewares/auth';

export const brandRoutes = [
  {
    path: '/brands',
    component: () =>
      import(
        /* webpackChunkName: "brands" */ '../../views/inventory/brands/Index'
      ),
    name: 'brands',
    meta: {
      middleware: [auth],
      requiredPermissions: ['inventory-brand-manage'],
    },
  },
  {
    path: '/brands/:id',
    component: () =>
      import(
        /* webpackChunkName: "brands" */ '../../views/inventory/brands/Form'
      ),
    name: 'update-brands',
    meta: {
      middleware: [auth],
      requiredPermissions: ['inventory-brand-manage'],
    },
  },
  {
    path: '/create-brands',
    component: () =>
      import(
        /* webpackChunkName: "brands" */ '../../views/inventory/brands/Form'
      ),
    name: 'create-brands',
    meta: {
      middleware: [auth],
      requiredPermissions: ['inventory-brand-manage'],
    },
  },
];
